export default {
  /* Event Members */
  setEventMembers(state, eventMembers) {
    state.eventMembers = eventMembers;
  },
  setEventMembersCount(state, eventMembersCount) {
    state.eventMembersCount = eventMembersCount;
  },
  setEventMembersLoading(state, eventMembersLoading) {
    state.isEventMembersLoading = eventMembersLoading;
  }
};
